var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-2 justify-content-between align-items-center"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-auto mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" 優惠券管理 ")]), _c('div', {
    staticClass: "col-12 col-xl-auto d-flex flex-wrap align-items-center justify-content-end"
  }, [_c('b-button', {
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('i', {
    staticClass: "mdi mdi-download"
  }), _vm._v("匯出")]), _vm.upperCustomer.id ? [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-add",
      modifiers: {
        "modal-add": true
      }
    }],
    staticClass: "mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v(" 手動給券 ")])] : _vm._e()], 2)]), _c('div', {
    staticClass: "mb-3"
  }, [_c('b-button-group', {
    staticClass: "coupon-view-switch-group"
  }, [_c('b-button', {
    class: {
      'coupon-view-switch-active': _vm.activeView === 'wallet'
    },
    attrs: {
      "variant": "light"
    },
    on: {
      "click": function click($event) {
        return _vm.switchView('wallet');
      }
    }
  }, [_vm._v(" 目前券匣 ")]), _c('b-button', {
    class: {
      'coupon-view-switch-active': _vm.activeView === 'history'
    },
    attrs: {
      "variant": "light"
    },
    on: {
      "click": function click($event) {
        return _vm.switchView('history');
      }
    }
  }, [_vm._v(" 使用紀錄 ")])], 1)], 1), _vm.showFilter ? [_c('div', {
    staticClass: "d-flex flex-wrap align-items-center mb-2"
  }, [_vm.activeView !== 'history' ? _c('b-form-select', {
    staticClass: "mr-2",
    staticStyle: {
      "max-width": "160px",
      "height": "35px",
      "padding-top": "4px",
      "padding-bottom": "4px"
    },
    attrs: {
      "options": _vm.statusOptions
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.status_for_admin,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "status_for_admin", $$v);
      },
      expression: "query.status_for_admin"
    }
  }) : _vm._e(), _c('b-form-select', {
    staticClass: "mr-3",
    staticStyle: {
      "max-width": "160px",
      "height": "35px",
      "padding-top": "4px",
      "padding-bottom": "4px"
    },
    attrs: {
      "options": _vm.branchOptions
    },
    on: {
      "change": _vm.handlePageReset
    },
    model: {
      value: _vm.query.branch_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "branch_id", $$v);
      },
      expression: "query.branch_id"
    }
  }), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-advanced-search",
      modifiers: {
        "collapse-advanced-search": true
      }
    }],
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "variant": "outline-info"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-magnify mt-1 mr-1"
  }), _vm._v("進階搜尋 ")])], 1), _c('b-collapse', {
    attrs: {
      "id": "collapse-advanced-search"
    },
    model: {
      value: _vm.isAdvancedSearchVisible,
      callback: function callback($$v) {
        _vm.isAdvancedSearchVisible = $$v;
      },
      expression: "isAdvancedSearchVisible"
    }
  }, [_c('b-card', [_c('b-form', [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-xl-center mb-3"
  }, [_c('span', {
    staticClass: "mr-2 mb-2 mb-xl-0 font-weight-bold text-nowrap"
  }, [_vm._v("篩選")]), _c('b-form-select', {
    staticClass: "advanced-search-control mr-2 mb-2 mb-xl-0",
    staticStyle: {
      "max-width": "160px"
    },
    attrs: {
      "options": _vm.dateTypeOptions
    },
    model: {
      value: _vm.query.date_type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "date_type", $$v);
      },
      expression: "query.date_type"
    }
  }), _c('span', {
    staticClass: "mr-2 mb-2 mb-xl-0 text-nowrap"
  }, [_vm._v("從")]), _c('div', {
    staticClass: "mr-2 mb-2 mb-xl-0",
    staticStyle: {
      "min-width": "150px"
    }
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "開始日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "value": _vm.query.after
    },
    on: {
      "selected": _vm.handleRedeemAfterSelected
    }
  })], 1), _c('span', {
    staticClass: "mr-2 mb-2 mb-xl-0 text-nowrap"
  }, [_vm._v("到")]), _c('div', {
    staticClass: "mb-2 mb-xl-0",
    staticStyle: {
      "min-width": "150px"
    }
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "結束日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "value": _vm.query.before
    },
    on: {
      "selected": _vm.handleRedeemBeforeSelected
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-button', {
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "mdi mdi-restart"
  }), _vm._v(" 重置條件")]), _c('b-button', {
    staticClass: "mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" 搜尋 ")])], 1)])], 1)], 1), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋會員名稱、手機、外部編碼"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword_v2,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword_v2", $$v);
      },
      expression: "query.keyword_v2"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)] : _vm._e(), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.redeemCodes,
      "fields": _vm.filteredFields
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": data.item.redeem_at ? 'outline-danger' : 'outline-success',
            "disabled": _vm.processingRedeemCodeId === data.item.hash_id
          },
          on: {
            "click": function click($event) {
              return _vm.handleToggleRedeem(data.item);
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.redeem_at ? "取消核銷" : "手動核銷") + " ")])];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-add",
      "title": "手動給券"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.assignRedeemCodeByBundle
          }
        }, [_vm._v(" 確定 ")])];
      }
    }])
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "優惠券"
    }
  }, [_c('vue-typeahead-bootstrap', {
    attrs: {
      "data": _vm.filteredRedeem,
      "showOnFocus": true,
      "serializer": function serializer(item) {
        return item.name;
      },
      "placeholder": "請輸入獎項名稱"
    },
    on: {
      "hit": function hit($event) {
        _vm.selectedRedeemCodeBundle = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "suggestion",
      fn: function fn(_ref2) {
        var data = _ref2.data;
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-badge', {
          attrs: {
            "variant": "outline-dark mr-2"
          }
        }, [_vm._v("獎項種類")]), _c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(data.name))])], 1), _c('div', {
          staticClass: "small py-2"
        }, [_vm._v(" " + _vm._s(data.description) + " ")]), _c('div', {
          staticClass: "small font-weight-bold"
        }, [_c('span', [_vm._v(_vm._s(data.start_at))]), _c('span', {
          staticClass: "mx-2"
        }, [_vm._v("-")]), _c('span', [_vm._v(_vm._s(data.end_at))])])];
      }
    }]),
    model: {
      value: _vm.redeemKeyWord,
      callback: function callback($$v) {
        _vm.redeemKeyWord = $$v;
      },
      expression: "redeemKeyWord"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }